export const navLinks = [
  { href: '#how-it-works', label: 'Process' },
  { href: '#services', label: 'Services' },
  { href: '#pricing', label: 'Pricing' },
  { href: '#store', label: 'Store' },
  { href: '/auth', label: 'Login', emphasized: true },
];

export const heroStats = [
  { value: '12K+', label: 'Orders Delivered' },
  { value: '99%', label: 'Satisfaction Rate' },
  { value: '24H', label: 'Turnaround' },
];

export const marqueeItems = [
  'Documents',
  'Brochures',
  'Certificates',
  'Reports',
  'Portfolios',
  'Booklets',
  'Posters',
  'Flyers',
];

export const workflowSteps = [
  {
    number: '01',
    title: 'Fill Your Details',
    description:
      'Enter your contact information, delivery address, and special instructions for your order.',
  },
  {
    number: '02',
    title: 'Upload Your Files',
    description:
      'Share your document in PDF, Word, image, or spreadsheet format. Files up to 100MB are supported.',
  },
  {
    number: '03',
    title: 'Choose Print Options',
    description:
      'Pick your paper size, print mode, quantity, delivery speed, and binding. Pricing updates instantly.',
  },
  {
    number: '04',
    title: 'Pay & Confirm',
    description:
      'Use Cashfree for live orders, or keep sandbox mode enabled while you finish setup and testing.',
  },
  {
    number: '05',
    title: 'Delivered to You',
    description:
      'We print, pack, and dispatch with care so your order arrives ready to use.',
  },
];

export const services = [
  {
    badge: 'DOC',
    title: 'Document Printing',
    description:
      'Black-and-white or color printing for reports, assignments, contracts, forms, and office packs.',
    tag: 'From Rs. 2.5/page',
  },
  {
    badge: 'BIND',
    title: 'Book and Booklet Binding',
    description:
      'Spiral, saddle, and perfect binding for portfolios, presentations, manuals, and coursework.',
    tag: 'From Rs. 29',
  },
  {
    badge: 'POST',
    title: 'Photo and Poster Prints',
    description:
      'High-resolution large-format work on matte or gloss stock for visual projects and displays.',
    tag: 'From Rs. 29',
  },
  {
    badge: 'MKT',
    title: 'Brochures and Flyers',
    description:
      'Marketing material in vivid color with support for folded handouts, menus, and event collateral.',
    tag: 'From Rs. 5/piece',
  },
  {
    badge: 'CARD',
    title: 'Certificates and Cards',
    description:
      'Clean presentation printing on premium stock for invitations, certificates, and visiting cards.',
    tag: 'From Rs. 15/card',
  },
  {
    badge: 'FAST',
    title: 'Same-Day Delivery',
    description:
      'Rush jobs are available for nearby orders placed early in the day and packed for quick dispatch.',
    tag: 'Express available',
  },
];

export const pricingPlans = [
  {
    name: 'Basic',
    description: 'For individuals with occasional print needs.',
    price: 'Rs. 2.5',
    priceSuffix: 'per page, black and white',
    featured: false,
    cta: 'Get Started',
    features: [
      'A4 black and white printing',
      'Standard paper stock',
      'Next-day dispatch',
      'Ideal for short documents',
    ],
  },
  {
    name: 'Pro',
    description: 'For designers, students, and professionals who need polish.',
    price: 'Rs. 6',
    priceSuffix: 'per page, full color',
    featured: true,
    badge: 'Most Popular',
    cta: 'Start Printing',
    features: [
      'Full color printing',
      'Premium paper stock',
      'Same-day delivery support',
      'Binding-ready output',
      'Best for portfolios and proposals',
    ],
  },
  {
    name: 'Business',
    description: 'For teams with bulk orders and recurring print schedules.',
    price: 'Custom',
    priceSuffix: 'volume pricing',
    featured: false,
    cta: 'Contact Us',
    features: [
      'All Pro features',
      'Priority turnaround',
      'Bulk order support',
      'Monthly billing workflow',
    ],
  },
];

export const testimonials = [
  {
    initial: 'P',
    name: 'Priya Sharma',
    role: 'Research Scholar, Delhi University',
    quote:
      'My thesis prints came out clean, sharp, and perfectly packed. The turnaround saved me during submission week.',
  },
  {
    initial: 'R',
    name: 'Rahul Mehta',
    role: 'Operations Head, TechStart',
    quote:
      'We use Art-Taste for team handbooks and workshop kits. Pricing is fair and the service stays reliable.',
  },
  {
    initial: 'A',
    name: 'Anika Joshi',
    role: 'Event Manager, Faridabad',
    quote:
      'Short-notice brochure orders have gone smoothly every time. The color quality and finishing are strong.',
  },
];

export const adminTabs = [
  { key: 'dashboard', label: 'Dashboard', status: '' },
  { key: 'orders', label: 'All Orders', status: '' },
  { key: 'pending', label: 'Pending', status: 'paid' },
  { key: 'printed', label: 'Printed', status: 'printed' },
  { key: 'delivered', label: 'Delivered', status: 'delivered' },
];

export const defaultOrderState = {
  customer: {
    name: '',
    phone: '',
    email: '',
    address: '',
  },
  printOptions: {
    type: 'bw',
    size: 'A4',
    copies: 1,
    pages: 1,
    binding: 'none',
    delivery: 'standard',
  },
  notes: '',
};
